
import { Observable } from './druid/./druid/Observable';
import { buffer } from './druid/./druid/operator/buffer';

Observable.prototype.buffer = buffer;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    buffer: typeof buffer;
  }
}